import { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { DataGrid, GridOverlay, useGridSlotComponentProps } from '@material-ui/data-grid'
import Pagination from '@material-ui/lab/Pagination'

import ViewComfy from '@material-ui/icons/ViewComfy';
import PersonAdd from '@material-ui/icons/PersonAdd';
import SearchOutlined from '@material-ui/icons/SearchOutlined';
import Close from '@material-ui/icons/Close';
import OrganizationModal from '../../../components/admin/admin-user/company-modal/index'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router'
import { operators } from '../../../api/'
import { useStoreRehydrated } from '../../../store'

const useStyles = makeStyles(theme => ({
	card_styles: {
		height: '80vh',
	},
	table_styles: {
		marginTop: '20px',
		height: '60vh',
	},
}))

function CustomPagination() {
	const { state, apiRef } = useGridSlotComponentProps()

	return (
		<Grid className="flex flex-row items-center w-full justify-between px-2">
			<Grid className="flex flex-row items-center">
				<Typography variant="body2" className="mr-2">Rows per page:</Typography>
				<Select
					value={state.pagination.pageSize}
					onChange={(e) => apiRef.current.setPageSize(e.target.value)}
					disableUnderline
				>
					{[5, 8, 10, 20, 100].map((size) => (
						<MenuItem key={size} value={size}>
							{size}
						</MenuItem>
					))}
				</Select>
			</Grid>
			<Pagination
				className="p-2"
				color="primary"
				count={state.pagination.pageCount}
				page={state.pagination.page + 1}
				onChange={(event, value) => apiRef.current.setPage(value - 1)}
				showFirstButton
				showLastButton
			/>
		</Grid>
	)
}

const Organization = () => {
	const isRehydrated = useStoreRehydrated()
	const [pageSize, setPageSize] = useState(8)
	// const dataTypeOfReport = ['ประจำที่', 'เคลื่อนที่']
	const classes = useStyles()
	const history = useHistory()
	const [organization, setOrganization] = useState([])
	const [isDataLoading, setIsDataLoading] = useState(false)
	// const [organizationData, setOrganizationData] = useState([])
	const [rowsData, setRowsData] = useState([])
	const [searchText, setSearchText] = useState('');
	const [openCRUDModal, setOpenCRUDModal] = useState(false)

	const columns = [
		{
			field: 'id',
			headerName: 'ลำดับ',
			flex: 0.8,
			headerAlign: 'left',
			align: 'left',
		},
		{
			field: 'operatorName',
			headerName: 'ชื่อผู้ประกอบการ',
			flex: 1,
			headerAlign: 'left',
			align: 'left',
		},
		{
			field: 'typesOfReports',
			headerName: 'ประเภทรายงาน',
			flex: 1,
			headerAlign: 'left',
			align: 'left',
			renderCell: params => {
				return (
					<Grid className="flex flex-row justify-center items-center">
						{params.value.map((e, index) => (
							<Grid
								key={e + index}
								className={`rounded-full py-1 px-4 m-0.5 font-bold text-xs border ${classes.type_of_report}`}>
								{e.qosTypeName}
							</Grid>
						))}
					</Grid>
				)
			},
		},
		{
			field: 'establishmentStatus',
			headerName: 'สถานะสถานประกอบการ',
			flex: 1,
			headerAlign: 'center',
			align: 'center',
			renderCell: params => {
				const now = new Date();
				const startDate = params.row.startDate ? new Date(params.row.startDate) : null;
				const endDate = params.row.endDate ? new Date(params.row.endDate) : null;

				let statusText = "ดำเนินกิจการอยู่";
				let statusColor = "green";

				if (endDate && now > endDate) {
					statusText = "หยุดให้บริการ";
					statusColor = "gray";
				} else if (startDate && now < startDate) {
					statusText = "ยังไม่เริ่มให้บริการ";
					statusColor = "#E65100"; // Dark Orange
				}

				return (
					<Typography style={{ color: statusColor, fontWeight: 'bold' }}>
						{statusText}
					</Typography>
				);
			},
		},
		{
			field: 'actions',
			headerName: 'การกระทำ',
			flex: 1,
			headerAlign: 'center',
			align: 'center',
			renderCell: params => (
				<>
					<Grid
						className="text-center text-blue_header cursor-pointer"

						onClick={() =>
							history.push({
								pathname: `/admin/organization/${params.row.id}`,
								// state: {
								// 	operatorsID: params.row.id,
								// },
							})
						}>
						ดูรายละเอียด
					</Grid>
					<Divider orientation="vertical" flexItem style={{ margin: "16px" }} />
					<Grid
						className="text-center text-blue_header cursor-pointer"
						onClick={() =>
							history.push({
								pathname: `/admin/organization/editprofile/${params.row.id}`,
							})
						}
					>
						จัดการข้อมูล
					</Grid>
				</>
			),
		},
	]

	/** ------------------------------------ */

	const onLanding = async () => {
		setIsDataLoading(true)
		const res = await operators.getOperatorsAll()
		if (res) {
			if (res.status === 200) {
				const fetchedOrg = res.data
				const preprocessedArr = fetchedOrg.map(item => {
					return {
						id: item.id ?? '',
						operatorName: item.operatorName ?? '',
						typesOfReports: item.operatorQOS,
						startDate: item.startDate,
						endDate: item.endDate,
					}
				})

				// setOrganizationData(fetchedOrg)
				setRowsData(preprocessedArr)
				setOrganization(preprocessedArr)
			}
		}
		setIsDataLoading(false)
	}

	const onSearhResult = (e) => {
		const { value } = e.target
		// Save to local storage
		localStorage.setItem('searchTextOrganization', value);

		const searchedResults = rowsData.filter(row => {
			return row.operatorName.includes(value)
		})

		setOrganization(searchedResults)
	}

	/** ------------------------------------ */

	// Main Rendering

	useEffect(() => {
		if (isRehydrated) {
			const savedSearch = localStorage.getItem('searchTextOrganization') || '';
			if (savedSearch) {
				setSearchText(savedSearch);
			}
			onLanding()
		}
	}, [isRehydrated])

	useEffect(() => {
		if (rowsData.length > 0 && searchText) {
			const searchedResults = rowsData.filter(row => {
				return row.operatorName.includes(searchText)
			})
			setOrganization(searchedResults)
		}
	}, [rowsData])

	return (
		<Grid className="flex flex-col p-10">
			<Card
				className={`${classes.card_styles} border-card_top_border border-t-4`}>
				<CardContent className="flex flex-col">
					<Grid className="flex flex-row gap-x-3">
						<ViewComfy />
						<Typography>รายชื่อผู้ประกอบการ</Typography>
					</Grid>
					<Grid className="my-3">
						<Divider />
					</Grid>
					<Grid className="flex flex-row justify-end gap-x-3 my-4">
						<TextField
							className="w-full lg:w-4/12"
							size="small"
							placeholder="ค้นหาโดย ชื่อผู้ประกอบการ"
							value={searchText}
							onChange={e => {
								setSearchText(e.target.value);
								onSearhResult(e);
							}}
							label=""
							variant="outlined"
							InputProps={{
								startAdornment: (
									<SearchOutlined style={{ color: 'rgba(0,0,0,0.54)', marginRight: 8 }} />
								),
								endAdornment: searchText && (
									<Close
										onClick={() => {
											setSearchText('');
											localStorage.removeItem('searchTextOrganization');
											onSearhResult({ target: { value: '' } });
										}}
										style={{
											cursor: 'pointer',
											color: 'rgba(0,0,0,0.54)',
										}}
									/>
								)
							}}
						/>
						<Button
							variant="contained"
							color="secondary"
							size="large"
							onClick={() => history.push('/admin/organization/add')}>
							<PersonAdd className="mr-1" />
							<Typography variant="button">เพิ่ม</Typography>
						</Button>
					</Grid>
					<Grid className={classes.table_styles}>
						<DataGrid
							disableSelectionOnClick
							disableColumnMenu
							rows={organization}
							columns={columns}
							rowsPerPageOptions={[5, 8, 10, 20, 100]}
							pageSize={pageSize}
							onPageSizeChange={size => setPageSize(size)}
							components={{
								Pagination: CustomPagination,
								NoRowsOverlay: () => {
									if (!isDataLoading) {
										return <GridOverlay>ไม่พบข้อมูล</GridOverlay>;
									} else {
										return <GridOverlay>กำลังประมวลผลข้อมูล โปรดรอสักครู่..</GridOverlay>;
									}
								}
							}}
						/>
					</Grid>
				</CardContent>
			</Card>

			<OrganizationModal
				open={openCRUDModal}
				onClose={e => setOpenCRUDModal(false)}
				userModalType={`add`}
			// Adding States

			// Save Button Logic
			/>
		</Grid>
	)
}

export default Organization
